import './Styles.scss';

const hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');

const initIntroCrossroad = (section) => {
	const items = section.querySelectorAll('[data-intro-crossroad-item]');
	const backgrounds = section.querySelectorAll('[data-intro-crossroad-background]');
	let requestedBackground = null;

	const hideBackgrounds = () => {
		backgrounds.forEach((background) => {
			background.classList.remove('is-active');
		});
	};

	const deactivateBackgrounds = () => {
		requestedBackground = null;
		hideBackgrounds();
	};

	const loadBackground = (background) => {
		if (background.dataset.introCrossroadLoaded === 'true') {
			return Promise.resolve(true);
		}

		if (background.introCrossroadLoadPromise) {
			return background.introCrossroadLoadPromise;
		}

		const image = background.querySelector(
			'img[data-intro-crossroad-src]'
		);

		if (!image) {
			return Promise.resolve(false);
		}

		background.introCrossroadLoadPromise = new Promise((resolve) => {
			const finish = (loaded) => {
				image.removeEventListener('load', handleLoad);
				image.removeEventListener('error', handleError);

				if (loaded) {
					background.dataset.introCrossroadLoaded = 'true';
				}

				resolve(loaded);
			};
			const handleLoad = () => finish(true);
			const handleError = () => finish(false);

			image.addEventListener('load', handleLoad);
			image.addEventListener('error', handleError);

			background
				.querySelectorAll('source[data-intro-crossroad-srcset]')
				.forEach((source) => {
					source.srcset = source.dataset.introCrossroadSrcset;
				});

			image.srcset = image.dataset.introCrossroadSrcset;
			image.src = image.dataset.introCrossroadSrc;

			if (image.complete) {
				finish(image.naturalWidth > 0);
			}
		});

		background.introCrossroadLoadPromise.then(() => {
			delete background.introCrossroadLoadPromise;
		});

		return background.introCrossroadLoadPromise;
	};

	const activateBackground = (index) => {
		const background = section.querySelector(
			`[data-intro-crossroad-background="${index}"]`
		);

		requestedBackground = background;
		hideBackgrounds();

		if (background) {
			loadBackground(background).then((loaded) => {
				if (loaded && requestedBackground === background) {
					background.classList.add('is-active');
				}
			});
		}
	};

	items.forEach((item) => {
		const index = item.dataset.introCrossroadItem;

		item.addEventListener('mouseenter', () => {
			if (hoverQuery.matches) {
				activateBackground(index);
			}
		});

		item.addEventListener('mouseleave', () => {
			if (hoverQuery.matches) {
				deactivateBackgrounds();
			}
		});

		item.addEventListener('focusin', () => {
			if (hoverQuery.matches) {
				activateBackground(index);
			}
		});

		item.addEventListener('focusout', () => {
			if (hoverQuery.matches) {
				deactivateBackgrounds();
			}
		});
	});
};

document.querySelectorAll('[data-intro-crossroad]').forEach(initIntroCrossroad);
